import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import { BUTTON_THEME_BLACK } from "./themes";
import styles from "./styles.module.scss";

const PrimaryButtonLink = (props) => {
    const {
        text,
        to,
        autoFocus,
        theme
    } = props;

    const className = `${ styles.primaryButton } ${ styles.buttonLink } ${ styles[theme] }`;

    const isInternalUrl = to.charAt(0) === "/";

    if (isInternalUrl) {
        return (
            <Link className={ className } autoFocus={ autoFocus } to={ to }>
                <span className={ styles.label }>{ text }</span>
            </Link>
        );
    }

    // [SC] 07/25/2019 react-router Link tags only handle relative urls properly, and break when external
    //      urls contain a protocol (which ours do). As such if we're not on a relative url, just make a
    //      normal anchor tag
    return (
        <a className={ className } autoFocus={ autoFocus } href={ to }>
            <span className={ styles.label }>{ text }</span>
        </a>
    );
};

PrimaryButtonLink.defaultProps = {
    autoFocus: false,
    theme: BUTTON_THEME_BLACK
};

PrimaryButtonLink.propTypes = {
    text: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
    autoFocus: PropTypes.bool,
    theme: PropTypes.string
};

export default PrimaryButtonLink;
